const slugify = (value = '', separator = '-') => value
    .toString()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, separator)
    .replace(/^-+|-+$/g, '');

export default slugify;
